import client from '../httpClient';

const libraryCopyApi = (params) => {
  return client.post('/libraries/copy', params, { isShowLoading: false });
};

export default libraryCopyApi;
